import { useTranslation } from 'react-i18next';

import { getPath } from '@services/RouteService/paths';

import {
    BreadcrumbsWrapper,
    Divider,
    HomeLink,
    HomeText,
    PathText,
} from './BreadcrumbsNavigation.styled';

interface BreadcrumbsNavigationProps {
    path: string;
}

export const BreadcrumbsNavigation = ({ path }: BreadcrumbsNavigationProps) => {
    const { t } = useTranslation();

    return (
        <BreadcrumbsWrapper>
            <HomeLink to={getPath({ path: '/' })}>
                <HomeText>{t('HOME')}</HomeText>
            </HomeLink>
            <Divider>/</Divider>
            <PathText data-testid="zwPZBAw">{path}</PathText>
        </BreadcrumbsWrapper>
    );
};
